import { render, staticRenderFns } from "./TabInventarisatie.vue?vue&type=template&id=1d2a8438"
import script from "./TabInventarisatie.vue?vue&type=script&lang=js"
export * from "./TabInventarisatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports